// apps/web/src/pages/author/use-debounced-recipe.ts
//
// Phase 8 — debounce hook used by the live-preview pane (AUTHR-04 / D-06).
// Defaults to a 200ms debounce in caller code (PreviewPane in Plan 10
// hard-codes `useDebouncedRecipe(liveRecipe, 200)` per UI-SPEC §"Debounce
// + validation gate"). The hook itself accepts any delayMs for testability.
//
// Generic over T so it can wrap any recipe-shaped value (or any value at all)
// without losing type information. Returns the latest stable value once the
// delay window elapses with no further change.
//
// Source: 08-RESEARCH.md §"Live-preview debounce hook" (lines 925-939).
import { useEffect, useState } from "react";

export function useDebouncedRecipe<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
